import { Component, OnInit } from "@angular/core";
import { FeaturedPost } from "src/app/models/blog-post";
import { BlogService } from "src/app/services/blog.service";

@Component({
  selector: "app-testimonials-section",
  templateUrl: "./testimonials-section.component.html",
  styleUrls: ["./testimonials-section.component.sass"],
})
export class TestimonialsSectionComponent implements OnInit {
  firstThreePosts: FeaturedPost[] = [];

  constructor(private blogService: BlogService) {}

  ngOnInit(): void {
    this.loadTestimonials();
  }

  loadTestimonials(): void {
    this.blogService.getTestimonials().subscribe((response) => {
      console.log(response.data.articles);
      this.firstThreePosts = response.data.articles
        .filter((post) => post.cover?.url)
        .slice(0, 3);
    });
  }

  getImageUrl(url: string): string {
    return this.blogService.getImageUrl(url);
  }
}
